import React, { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

const Print = ({ name, opNumber, billCode }) => {
  const barcodeRef = useRef(null);

  useEffect(() => {
    if (opNumber) {
      // Generate barcode for the OP number using JsBarcode
      JsBarcode(barcodeRef.current, opNumber, {
        format: "CODE128", // Barcode format
        width: 2, // Barcode width
        height: 40, // Barcode height
        displayValue: false, // Do not display value under the barcode
        margin: 0, // Margin around the barcode
      });
    }
  }, [opNumber]);

  const handlePrint = () => {
    // Create a new print window
    const printWindow = window.open("", "", "height=600,width=800");
    const content = `
      <html>
      <head>
        <title>Print</title>
        <style>
          body { font-family: Arial, sans-serif; }
          .barcode-container { text-align: center; }
          .barcode-header { font-size: 20px; font-weight: bold; }
          .barcode-details { margin-top: 1px; text-align: center; font-weight: bold;  }
          .barcode-text { font-size: 20px; margin: 5px 0; }
          .barcode-details1 { margin-top : 20px;}
          .barcode-details2 {font-size: 20px; font-weight: bold;}
          .barcode-text1 { font-size: 15px; }
          @media print { 
            .print-only { display: block; } 
          }
          @media screen { 
            .print-only { display: none; } 
          }
        </style>
      </head>
      <body>
        <div class="barcode-container">
      
          <div class="barcode">
            
          </div>
          <div class="barcode-details2">
            <p class="barcode-text1">${name}</p>
            </div>
          <div class="barcode-details1">
            <svg width="200" height="60">
              ${barcodeRef.current.innerHTML}
            </svg>
            </div>
        
            <div class="barcode-details">
            <p class="barcode-text"><strong>OP Code:</strong> ${opNumber}</p>
            <p class="barcode-text"><strong>Bill Code:</strong> ${billCode}</p>
          </div>
        </div>
      </body>
      </html>
    `;
    printWindow.document.write(content);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  return (
    <div style={styles.container}>
      {opNumber && (
        <div style={styles.barcodeContainer}>
          <div style={styles.barcodeDetails}>
            <p style={styles.barcodeText}>
              <strong>Name:</strong> {name}
            </p>
            {/* <h2 style={styles.barcodeHeader}>OP Number Barcode:</h2> */}
            <svg ref={barcodeRef} style={styles.barcode}></svg>{" "}
            {/* SVG element for barcode */}
            <p style={styles.barcodeText}>
              <strong></strong> {opNumber}
              <strong></strong> - {billCode}
            </p>
            {/* <p style={styles.barcodeText}>
              <strong>Bill Code:</strong> {billCode}
            </p> */}
          </div>
        </div>
      )}

      {opNumber && (
        <button style={styles.printButton} onClick={handlePrint}>
          Print
        </button>
      )}
    </div>
  );
};

// Inline styles for the component
const styles = {
  container: {
    padding: "20px",
    textAlign: "center",
    fontFamily: "Arial, sans-serif",
  },
  barcodeContainer: {
    marginTop: "20px",
    textAlign: "center",
  },
  barcodeHeader: {
    fontSize: "20px",
    marginBottom: "10px",
    fontWeight: "bold",
  },
  barcode: {
    maxWidth: "100%",
    height: "auto",
  },
  barcodeDetails: {
    marginTop: "10px",
    textAlign: "center",
  },
  barcodeText: {
    fontSize: "18px",
    margin: "5px 0",
    fontWeight: "900%",
    color: "black",
  },
  printButton: {
    padding: "10px 20px",
    fontSize: "16px",
    cursor: "pointer",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "4px",
    marginTop: "20px",
  },
};

export default Print;
